

export interface IExportToCsvOptions {
    // Optional column headers
    headers?: string[];
    records: string[][];
    fileName: string;
    // Field separator – defaults to ","
    separator?: string;
    // When false the UTF‑8 BOM (\uFEFF) is omitted. Default = true
    includeBom?: boolean;
}

export class CsvExporter {
    private static esc(value: unknown): string {
        return `${value ?? ""}`.replace(/"/g, '""');
    }

    static download({ headers, records, fileName, separator = ',', includeBom = true }: IExportToCsvOptions): void {
        const rows: string[] = [];

        if (headers?.length) {
            rows.push(headers.map(this.esc).join(separator));
        }

        for (const row of records) {
            rows.push(row.map(this.esc).join(separator));
        }

        const csvContent = (includeBom ? '\uFEFF' : '') + rows.join('\r\n');
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

        // Fallback‑free client‑side download
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();

        // Clean‑up
        URL.revokeObjectURL(link.href);
        document.body.removeChild(link);
    }
}
